import { type FunctionComponent } from 'react';

import { BreakPoints } from '@kanda-libs/ks-design-library';

import OmniSignDocumentsError from './Error';
import OmniSignDocumentsForm from './Form';
import OmniSignDocumentsLoader from './Loader';
import OmniSignDocumentsMobileButton from './MobileButton';
import useOmniSignDocuments from './useOmniSignDocuments';

const OmniSignDocumentsContent: FunctionComponent = () => {
  const { showLoader, showError, showForm } = useOmniSignDocuments();
  return (
    <>
      {showLoader && <OmniSignDocumentsLoader />}
      {showError && <OmniSignDocumentsError />}
      {showForm && (
        <BreakPoints
          desktop={<OmniSignDocumentsForm />}
          mobile={<OmniSignDocumentsMobileButton />}
        />
      )}
    </>
  );
};

export default OmniSignDocumentsContent;
